// extracted by mini-css-extract-plugin
export var banner = "_3c-0";
export var icon = "_3c-1";
export var message = "_3c-2";